import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { pushDataTrackerPageView } from 'approot/shared/data-tracker/data-tracker-push-pageview';
import {
  DropdownLink,
  DropdownItemDescription,
  DropdownItemLabelStrong,
  DropdownLinkDisabled,
} from 'approot/shared/dropdown/dropdown-item.style';
import { Dropdown } from 'approot/shared/dropdown/dropdown';
import { getUserClassPath } from 'approot/classes/classes.apollo';
import { pathWithParentId } from 'lib/router/router.util';
import { Props, ContentNavItemIntegrated } from './content-page-nav.constants';
import {
  getRelevantLinks,
  getLinkLabel,
  getItemTypeLabel,
  getLinkDisabledState,
} from './content-page-nav.utils';
import * as Styled from './content-page-nav.style';

const ContentPageNav = ({ item, otherItems, unitId }: Props) => {
  const { t } = useTranslation();

  const location = useLocation();

  const isIntegrated = !!(otherItems?.[0] as ContentNavItemIntegrated)
    ?.integratedSort;
  const items = getRelevantLinks(otherItems, isIntegrated);
  const label = getItemTypeLabel(item, otherItems, isIntegrated, t);

  return (
    <Styled.ContentDropdown>
      <Dropdown
        isSmall
        disabled={items?.length === 0}
        data-selector={`content-navigation-${item.label.toLowerCase()}`}
        aria-label={`${item.label} navigation, ${label}`}
        buttonElement={items?.length === 0 ? item.label : item.title || label}
        dropdownContents={
          otherItems
            ? items.map(i =>
                getLinkDisabledState(i) ? (
                  <DropdownLinkDisabled
                    data-selector="dropdown-item"
                    key={`${i.__typename}:${i.id}`}
                    $isDisabled
                    $isActive={
                      i.id === item.id && i.__typename === item.__typename
                    }
                    aria-current={
                      i.id === item.id && i.__typename === item.__typename
                        ? 'page'
                        : 'false'
                    }
                  >
                    <DropdownItemDescription data-selector="dropdown-item-type">
                      {getLinkLabel(i, items, t)}
                    </DropdownItemDescription>
                    <DropdownItemLabelStrong data-selector="dropdown-item-name">
                      {'name' in i ? i.name : i.label}
                    </DropdownItemLabelStrong>
                  </DropdownLinkDisabled>
                ) : (
                  <DropdownLink
                    data-selector="dropdown-item"
                    key={`${i.__typename}:${i.id}`}
                    to={pathWithParentId(i.slug, unitId)}
                    $isActive={
                      i.id === item.id && i.__typename === item.__typename
                    }
                    aria-current={
                      i.id === item.id && i.__typename === item.__typename
                        ? 'page'
                        : 'false'
                    }
                    onClick={() => {
                      const newPathname = getUserClassPath(i.slug);
                      if (newPathname !== location.pathname) {
                        pushDataTrackerPageView();
                      }
                    }}
                  >
                    <DropdownItemDescription data-selector="dropdown-item-type">
                      {getLinkLabel(i, items, t)}
                    </DropdownItemDescription>
                    <DropdownItemLabelStrong data-selector="dropdown-item-name">
                      {'name' in i ? i.name : i.label}
                    </DropdownItemLabelStrong>
                  </DropdownLink>
                )
              )
            : []
        }
      />
    </Styled.ContentDropdown>
  );
};

export default ContentPageNav;
